import md5 from 'md5';
import { DoRequest } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../../localStore';

export function getResponseFromCache(state: IAppState, hashedData: string): unknown {
  const responseFromCache = state.transientState.responseCache.items.find(
    element => element.hash === hashedData,
  );
  return responseFromCache != null ? responseFromCache.value : null;
}

export function getHashedRequest(doRequestPayload: DoRequest): string {
  return `${doRequestPayload.url}_${md5(encodeURI(JSON.stringify(doRequestPayload.body)))}`;
}
